export const titleIdentificationTypePaymentCaixa: {
  code: string;
  description: string;
}[] = [
  { code: '03', description: 'Não aceita pagamento com o valor divergente' },
];
